<template>
    <b-card-body>
        <!-- Table Container Card -->
        <b-card no-body class="mb-0" data-test="pending-approval-update-or-particulars-table">
            <b-card-header tag="h1" class="border-bottom primary">
                <h1 class="mb-0">Pending Approval - Update Of Particulars</h1>
            </b-card-header>

            <b-card-body>
                <b-table
                    ref="refPendingApprovalUpdateParticularsOfDirectorListTable"
                    class="position-relative"
                    :items="pendingUpdateOfDirectorsParticulars"
                    :fields="pendingApprovalUpdateParticularsOfDirectorTableColumns"
                    :current-page="pendingApprovalUpdateParticularsOfDirectorCurrentPage"
                    :per-page="pendingApprovalUpdateParticularsOfDirectorPerPage"
                    responsive
                    primary-key="userId"
                    :sort-by.sync="sortPendingApprovalUpdateParticularsOfDirectorBy"
                    :sort-desc.sync="isSortDirDescPendingApprovalUpdateParticularsOfDirector"
                    busy.sync="isPendingApprovalUpdateParticularsOfDirectorBusy"
                    :filter="pendingApprovalUpdateParticularsOfDirectorSearchQuery"
                >
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>

                    <template #cell(director.name) = "data">
                        <div style="max-width: 200px; min-width: 120px;"> {{ data.item.director.name }} </div>
                    </template>

                    <template #cell(particulars)="data" >
                        <table class="table table-bordered align-top">
                            <tr class="p-0">
                                <td :rowspan="data.item.updatedDirectorParticularList.length + 1" style="width:50px; border-top:none!important" class="p-1 align-top"> 
                                    {{ data.index + 1 }}
                                </td>   
                                <th class="text-nowrap px-1"> Name </th>
                                <th class="text-nowrap px-1"> Description </th>
                                <th class="text-nowrap px-1"> Current Value </th>
                                <th class="text-nowrap px-1"> New Value </th>
                            </tr>

                            <tr v-for="(particular, index) in data.item.updatedDirectorParticularList" :key="particular._id" class="p-0">
                                <td v-if="index == 0" :rowspan="data.item.updatedDirectorParticularList.length" style="width:250px;" class="p-1 align-top"> 
                                    {{ data.item.director.name }}
                                </td>               
                                <td style="width:210px" class="p-1 align-top"> 
                                    {{ particular.label }}
                                </td>
                                <td style="width:270px" class="p-1 align-top"> 
                                    {{ particular.changeFrom }}
                                </td>
                                <td style="width:270px" class="p-1 align-top"> 
                                    {{ particular.changeTo }}
                                </td>
                            </tr>
                        </table>
                    </template>

                    <!-- Column: Actions -->
                    <template #cell(actions)= "data">
                        <div class="cursor-pointer">
                            <div v-if="isUserAdmin">
                                <b-dropdown size="sm" menu-class="" dropright variant="link" toggle-class="text-decoration-none" no-caret>
                                    <template #button-content>
                                        <feather-icon icon="MoreVerticalIcon"/>
                                    </template>

                                    <b-dropdown-item
                                        :data-test="`view-${data.item.email}`"
                                        @click="view(data.item)"
                                    >
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="EyeIcon" />
                                            <span style="padding-top: .1em; padding-left: .5em">View</span>
                                        </div>
                                    </b-dropdown-item>

                                    <b-dropdown-item
                                        :data-test="`approve-${data.item.email}`"
                                        @click="approve(data.item)"
                                    >
                                        <div class="d-flex align-items-center">
                                            <feather-icon icon="CheckIcon" />
                                            <span style="padding-top: .1em; padding-left: .5em">Approve</span>
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>

                            <div 
                                v-else 
                                class="d-flex align-items-center justify-content-end" 
                                :data-test="`view-${data.item.email}`"
                                @click="view(data.item)"
                            >
                                <feather-icon icon="EyeIcon" />
                                <span style="padding-top: .1em; padding-left: .5em">View</span>
                            </div>
                        </div>
                    </template>
                </b-table>

                <loader v-if="isLoadingPendingApprovalUpdateParticularsOfDirector" data-type="Table" class="custom-loading" />

                <div class="mx-2 mb-2">
                    <b-row>
                        <b-col
                            cols="12"
                            sm="6"
                            class="
                                d-flex
                                align-items-center
                                justify-content-center justify-content-sm-start
                            "
                        >
                            <span class="text-muted"
                                >Showing {{ PendingApprovalUpdateParticularsOfDirectorDataMeta.from }} to {{ PendingApprovalUpdateParticularsOfDirectorDataMeta.to }} of
                                {{ PendingApprovalUpdateParticularsOfDirectorDataMeta.of }} entries</span
                            >
                        </b-col>
                        <!-- Pagination -->
                        <b-col
                            cols="12"
                            sm="6"
                            class="
                                d-flex
                                align-items-center
                                justify-content-center justify-content-sm-end
                            "
                        >
                            <b-pagination
                                v-model="pendingApprovalUpdateParticularsOfDirectorCurrentPage"
                                :total-rows="totalPendingApprovalUpdateParticularsOfDirectors"
                                :per-page="pendingApprovalUpdateParticularsOfDirectorPerPage"
                                first-number
                                last-number
                                class="mb-0 mt-1 mt-sm-0"
                                prev-class="prev-item"
                                next-class="next-item"
                            >
                                <template #prev-text>
                                    <feather-icon
                                        icon="ChevronLeftIcon"
                                        size="18"
                                    />
                                </template>
                                <template #next-text>
                                    <feather-icon
                                        icon="ChevronRightIcon"
                                        size="18"
                                    />
                                </template>
                            </b-pagination>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
        </b-card>
    </b-card-body>
</template>

<script>
import {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    // BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import { COMPANY } from "@/constants/config";

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BTable,
        BDropdown,
        BCardBody,
        BPagination,
        BCardHeader,
        BDropdownItem,
    },

    props: {
        payloadForPendingUpdateParticularsOfDirectorsTable: {
            type: Object,
            required: true
        },

        pendingUpdateOfDirectorsParticulars: {
            type: Array,
            required: true
        }
    },

    computed: {
        ...mapGetters({
            isUserAdmin: "auth/isAdmin",
        }),

        shouldShowCreateBtn() {
            if(this.isUserAdmin && this.companyStatus !== COMPANY.STATUS_PRE_INCORPORATED) 
                return true;
            return false;
        },
    },
    
    methods:{
        add(){
            this.$emit('add');
        },

        view(updateOfDirectorParticularsData) {
            this.$emit('view', updateOfDirectorParticularsData, "view");
        },

        approve(updateOfDirectorParticularsData) {
            this.$emit('approve', updateOfDirectorParticularsData, "approve");
        },
    },

    setup(props) {
        const {
            sortPendingApprovalUpdateParticularsOfDirectorBy,
            isPendingApprovalUpdateParticularsOfDirectorBusy,
            pendingApprovalUpdateParticularsOfDirectorPerPage,
            PendingApprovalUpdateParticularsOfDirectorDataMeta,
            isLoadingPendingApprovalUpdateParticularsOfDirector,
            pendingApprovalUpdateParticularsOfDirectorSearchQuery,
            pendingApprovalUpdateParticularsOfDirectorCurrentPage,
            pendingApprovalUpdateParticularsOfDirectorTableColumns,
            isSortDirDescPendingApprovalUpdateParticularsOfDirector,
            totalPendingApprovalUpdateParticularsOfDirectors,
            pendingApprovalUpdateParticularsOfDirectorPerPageOptions,
            refPendingApprovalUpdateParticularsOfDirectorListTable,
            
            refetchPendingApprovalUpdateParticularsOfDirectorData,
            filterOnPendingApprovalUpdateParticularsOfDirector,
        } = props.payloadForPendingUpdateParticularsOfDirectorsTable;

        return {
            sortPendingApprovalUpdateParticularsOfDirectorBy,
            isPendingApprovalUpdateParticularsOfDirectorBusy,
            pendingApprovalUpdateParticularsOfDirectorPerPage,
            PendingApprovalUpdateParticularsOfDirectorDataMeta,
            isLoadingPendingApprovalUpdateParticularsOfDirector,
            pendingApprovalUpdateParticularsOfDirectorSearchQuery,
            pendingApprovalUpdateParticularsOfDirectorCurrentPage,
            pendingApprovalUpdateParticularsOfDirectorTableColumns,
            isSortDirDescPendingApprovalUpdateParticularsOfDirector,
            totalPendingApprovalUpdateParticularsOfDirectors,
            pendingApprovalUpdateParticularsOfDirectorPerPageOptions,
            refPendingApprovalUpdateParticularsOfDirectorListTable,
            
            refetchPendingApprovalUpdateParticularsOfDirectorData,
            filterOnPendingApprovalUpdateParticularsOfDirector,
        };
    }
};
</script>

<style lang="scss" scoped>
    .table-responsive {
        overflow-x: inherit;
    }
</style>